(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ChatMessage', ChatMessage);

    ChatMessage.$inject = ['$resource', 'DateUtils'];

    function ChatMessage ($resource, DateUtils) {
        var resourceUrl =  'api/chat-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
